module.exports = __webpack_public_path__ + "img/card-image2.485277c8.png";